import Vue from 'vue';
import store from '@state/store';
import App from './app';
import router from '@router';
import '@components/global/_globals';
import { PtNotification } from '@pathao/ui-components/esm/Notification';
import Vuelidate from 'vuelidate';
import config from './config';
import initializeSentry from './sentry';
import { initializeFirebase, enableAnalytics, requestNotificationPermission } from './firebase';
import { registerOfflinePageServiceWorker, updateServiceWorker } from './utils/serviceWorker';

initializeFirebase();
requestNotificationPermission();
registerOfflinePageServiceWorker();
updateServiceWorker();
enableAnalytics();

Vue.use(PtNotification, {
  timeout: 5000,
});

Vue.use(Vuelidate);

const isProductionMode = process.env.NODE_ENV === 'production';

async function setupNotifications() {
  if (!store.getters['auth/loggedIn']) {
    return;
  }

  if ('Notification' in window) {
    const permission = await Notification.requestPermission();
    if (permission === 'granted') {
      await store.dispatch('auth/registerFCMToken');
    }
  }
}

if ('serviceWorker' in navigator) {
  setupNotifications();
}

// Don't warn about using the dev version of Vue in development
Vue.config.productionTip = isProductionMode;

if (isProductionMode && config.ENABLE_SENTRY) {
  initializeSentry();
}

Vue.prototype.$bus = new Vue();
new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app');
